import React from 'react'
import {Button, Col, Form, Input, Row} from 'antd'
import '../styles/authPage/login.css'
import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import logo from '../static/images/New_logo.jpg'
import apiRequest from '../hooks/ApiRequest'
import {Link} from 'react-router-dom/cjs/react-router-dom'
import TermsConditions from '../components/TermsConditions'
toast.configure()
// const token=useParams();
class SetPassword extends React.Component {
  constructor() {
    super()
    this.state = {
      loggedIn: false,
      api: process.env.REACT_APP_BASE_URL_AUTH + '/api/Auth/set-password',
      resetApi:
        process.env.REACT_APP_BASE_URL_AUTH + '/api/Auth/send-reset-link',
      status: 'Active',
      token: '',
      resendToken: false,
      email: '',
      userType: 'Customer',
      showPolicyModal: false,
      acceptedTerms: false,
      acceptedPrivacy: false,
      redirecttologin:true,
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const payload = {
          encryptedPassword: values?.encryptedPassword,
          encryptedToken: this.state.token,
        }
        this.passwordSet(payload)
      }
    })
  }
  fetchUserRole = async token => {
    try {
      const fetchURL = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/get-role-by-token?token=${encodeURIComponent(
        token,
      )}`
      const response = await apiRequest(fetchURL, 'GET')
      if (response?.data?.users[0]?.role === 'Customer') {
        this.setState({showPolicyModal: true})
      }
    } catch (error) {
      console.error('Error fetching quotations:', error)
    }
  }
  componentDidMount() {
    const query = window.location.search.substring(1)
    if (query.indexOf('&&red=') >= 0) {
      this.setState({redirecttologin: parseInt(query.split('&&red=')[1])})
      this.setState({token: query.split('&&red=')[0]})
    } else {
      this.setState({token: query})
      this.fetchUserRole(query.split('&&')[0])
    }
  }
  // api for setpassword
  async passwordSet(data) {
    const response = await apiRequest(this.state.api, 'POST', data)
    if (response.success) {
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      })
      if (this.state.redirecttologin) {
        this.props.history.push('/')
      } else {
        this.props.history.push('/home/users')
      }
    } else {
      if (response?.statusCode == 404) {
        toast.error(response.error, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
        })
        this.setState({
          resendToken: response?.data?.resendToken,
          email: response?.data?.email,
        })
      } else {
        toast.error(response.error, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
        })
      }
    }
  }
  //api for reset link
  async resendResetLink() {
    const response = await apiRequest(
      this.state.resetApi + `?email=${this.state.email}`,
      'POST',
    )
    if (response.success) {
      toast.success(response.data.message, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      })
    } else {
      toast.error(response.error, {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000,
      })
    }
  }

  render() {
    const {getFieldDecorator} = this.props.form

    return (
      <>
        <div
          className="body-height"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
          }}>
          <div
            className="bg-white"
            style={{
              boxShadow: '0 0 16px grey',
              padding: '30px',
              borderRadius: '10px',
              textAlign: 'center',
              width: '100%',
              maxWidth: '400px',
            }}>
            <div className="wrap-img">
              <img
                src={logo}
                alt="Logo"
                style={{width: '250px', height: '100px', marginBottom: '10px'}}
              />
            </div>

            <h2 className="h2-password">Set Password</h2>

            <Form onSubmit={this.handleSubmit} className="form-group-login">
              <Form.Item>
                {getFieldDecorator('encryptedPassword', {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your password',
                    },
                  ],
                })(
                  <Input.Password
                    placeholder="Password"
                    className="input-box"
                  />,
                )}
              </Form.Item>

              <Form.Item>
                {getFieldDecorator('confirmPassword', {
                  rules: [
                    {
                      required: true,
                      message: 'Please confirm your password',
                    },
                    {
                      validator: (rule, value, callback) => {
                        const password =
                          this.props.form.getFieldValue('encryptedPassword')
                        if (value && value !== password) {
                          callback('Passwords do not match!')
                        } else {
                          callback()
                        }
                      },
                    },
                  ],
                })(
                  <Input.Password
                    placeholder="Confirm Password"
                    className="input-box"
                  />,
                )}
              </Form.Item>

              <Form.Item>
                <Button
                  htmlType="submit"
                  size="large"
                  className="btn-bg-primary"
                  style={{
                    width: '100%',
                  }}>
                  SUBMIT
                </Button>
              </Form.Item>

              {this.state.resendToken && (
                <Link onClick={() => this.resendResetLink()}>
                  Click to reset link
                </Link>
              )}
            </Form>
          </div>
        </div>
        <TermsConditions
          visible={this.state.showPolicyModal}
          acceptedTerms={this.state.acceptedTerms}
          acceptedPrivacy={this.state.acceptedPrivacy}
          onTermsChange={checked => this.setState({acceptedTerms: checked})}
          onPrivacyChange={checked => this.setState({acceptedPrivacy: checked})}
          onAcceptAll={() => this.setState({showPolicyModal: false})}
        />
      </>
    )
  }
}

const WrappedNormalSetPasswordForm = Form.create({name: 'normal_setpassword'})(
  SetPassword,
)

export default WrappedNormalSetPasswordForm
